import {Injectable} from '@angular/core';

export interface Locale {
  lang: string;
  data;
}

@Injectable({
  providedIn: 'root'
})
export class CoreTranslationService {
  /**
   * Constructor
   *
   */
  constructor() {}

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Translate
   *
   * @param {Locale} args
   */
  translate(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(() => {
      // use setTranslation() with the third argument value as true to append translations instead of replacing them

    });
  }
}
